export default function MessageBubble({ message, isSelf }) {
  return (
    <div className={`flex ${isSelf ? "justify-end" : "justify-start"} mb-3`}>
      <div
        className={`max-w-[75%] px-4 py-2.5 rounded-2xl text-sm leading-relaxed ${
          isSelf
            ? "bg-terracotta text-white rounded-br-md"
            : "bg-cream text-walnut rounded-bl-md"
        }`}
      >
        <p className="whitespace-pre-wrap">{message.body}</p>
        <p className={`text-xs mt-1 ${isSelf ? "text-white/60" : "text-walnut-light/60"}`}>
          {new Date(message.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
        </p>
      </div>
    </div>
  );
}
